<template>
    <section class="comp_bookings_channel" @click="hidePopup()" style="padding-bottom: 200px;overflow-x: auto">
        <div class="comp_content">
            <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle mod--flex-wrap">
                <div class="col col--12">
                    <h1 class="part_ui_heading"><span>{{ $t('channel_manager') }}</span></h1>
                </div>
                <div class="col col--6 mod--left">
                    <label for="channel_id">{{ $t('select_range') }}</label>
                    <div class="part_ui_select">
                        <select name="date" id="date" v-model="date" v-on:change="changeDate">
                            <option v-for="(value, key) in selectDates" v-bind:value="key">
                                {{ value }}
                            </option>
                        </select>
                    </div>
                </div>
                <!--            <div class="col col&#45;&#45;6 mod&#45;&#45;right">-->
                <!--                <label for="channel_id">{{ $t("select_channel")}}</label>-->
                <!--                <div class="part_ui_select">-->
                <!--                    <select name="channel_id" id="channel_id" v-model="channel_id" v-on:change="changeChannel">-->
                <!--                        <option v-for="option in channels" :value="option.channel_id">-->
                <!--                            {{ option.channel_id }}-->
                <!--                        </option>-->
                <!--                    </select>-->
                <!--                </div>-->
                <!--            </div>-->
                <div class="col col--6 mod--right">
                    <label v-if="this.channel_id">{{ $t('channel') }}: {{ this.channel_id }}</label>
                    <label v-if="!this.channel_id">{{ $t('select_channel_in_settings') }}</label>
                </div>
            </header>
            <div class="wrp_comp_body" :class="[loading ? 'state-loading' : '']" style="height: 100%">
                <pull-to :top-load-method="reloadTable" :top-config="top_options"
                         v-on:scroll="handleGlobalScroll($event)">
                    <div class="elm_body_head mod--row mod--row-flex">
                        <div class="col col--left"></div>
                        <div class="col col--right">
                            <div class="elm_head_days mod--row mod--row-flex">
                                <div class="col" v-for="item in days" :key="item.id">
                                    {{ $t(item.day) }}<br/>{{ item.dateFormatted }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="elm_body_content mod--row mod--row-flex">
                        <div class="col wrp_comp_left">
                            <div class="wrp_table">
                                <div class="elm_cell"><span>{{ $t('free') }}</span></div>
                                <div class="elm_cell"><span>{{ $t('fix') }}</span></div>
                                <div class="elm_cell" v-if="show_tentative"><span>{{ $t('tentative') }}</span></div>
                                <div class="elm_cell"><span>{{ $t('opce') }}</span></div>
                                <div class="elm_cell mod--low"></div>
                                <template v-for="room in rooms">
                                    <div class="elm_cell" v-if="room.online_sync"><span>{{
                                            room.room_type.code
                                        }}</span></div>
                                </template>
                                <div class="elm_cell mod--low"></div>
                                <template v-for="rate in rates">
                                    <div class="elm_cell"><span
                                        v-bind:style="rate.price_type.parent_id ? 'color: #bababa' : ''">{{
                                            rate.price_list.code
                                        }} - {{ rate.price_type.code }}</span></div>
                                    <div class="elm_cell"><span
                                        v-bind:style="rate.price_type.parent_id ? 'color: #bababa; font-size: 10px' : 'font-size: 10px'"><em>vz. {{
                                            rate.price_list.code
                                        }} - {{ rate.price_type.code }}</em></span></div>
                                </template>
                                <div class="elm_cell mod--low"></div>
                                <div class="elm_cell" v-for="room in rooms"><span>{{ room.room_type.code }}</span>
                                </div>
                                <div class="elm_cell mod--high"><span>{{ $t('note_abbr') }}</span></div>
                            </div>
                        </div>
                        <div class="col wrp_comp_right" v-on:scroll="handleScroll($event)" id="maintable">
                            <div class="wrp_table">
                                <div class="mod--row mod--row-flex">
                                    <div class="col" v-for="item in days" :key="item.id">
                                        <div class="elm_cell"><span>{{
                                                getCalendarValue(item.date, 'free_rooms')
                                            }}</span></div>
                                        <div class="elm_cell">
                                            <span>{{ getCalendarValue(item.date, 'confirmed_rooms') }}</span></div>
                                        <div class="elm_cell" v-if="show_tentative">
                                            <span>{{ getCalendarValue(item.date, 'tentative_rooms') }}</span></div>
                                        <div class="elm_cell">
                                            <span>{{ getCalendarValue(item.date, 'unconfirmed_rooms') }}</span>
                                        </div>
                                        <div class="elm_cell mod--low"></div>
                                        <template v-for="room in rooms">
                                            <div class="elm_cell" v-if="room.online_sync" :class="{
                                            'mod--closed':getAvailabilityValue(item.date, room.room_type_id, 'closed'),
                                            'mod--sold-out':getAvailabilityValue(item.date, room.room_type_id, 'availability') <= 0
                                            }">
                                                <div class="part_ui_input"
                                                     v-touch:touchhold="showPopupRoom(item, room)"
                                                     v-on:click="handleInputClick($event)"
                                                     v-bind:data-date="item.date"
                                                     v-bind:data-room="room.room_type_id">
                                                    <input type="number"
                                                           :value="getAvailabilityValue(item.date, room.room_type_id, 'availability')"
                                                           v-on:focus="handleInputFocus($event)"
                                                           v-on:change="changeAvailability($event.target.value, item.date, room.room_type_id, 'availability')"/>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="elm_cell mod--low"></div>
                                        <template v-for="rate in rates">
                                            <div class="elm_cell" :class="{
                                        'mod--closed':getPriceValue(item.date,rate.pricetype_id, 'closed'),
                                        'mod--no-dependency':getPriceValue(item.date,rate.pricetype_id, 'disable_parent'),
                                        'mod--formula':getPriceValue(item.date,rate.pricetype_id, 'is_modified_price'),
                                        'mod--closed-formula':getPriceValue(item.date,rate.pricetype_id, 'closed_by_modifier')
                                    }">
                                                <template
                                                    v-if="getPriceValue(item.date,rate.pricetype_id, 'is_editable')">
                                                    <div class="part_ui_input"
                                                         v-touch:touchhold="showPopup(item, rate)"
                                                         v-on:click="handleInputClick($event, item.date, rate.pricetype_id)"
                                                         v-bind:data-date="item.date"
                                                         v-bind:data-rate="rate.pricetype_id">
                                                        <input type="number"
                                                               :value="getPriceValue(item.date, rate.pricetype_id, 'modified_price')"
                                                               v-on:focus="handleInputFocus($event)"
                                                               v-on:change="changePrice($event.target.value, item.date, rate.pricetype_id, 'price', $event.target)"/>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="part_ui_input"
                                                         v-touch:touchhold="showPopup(item, rate)"
                                                         v-on:click="handleInputDisabled()"
                                                         v-bind:data-date="item.date"
                                                         v-bind:data-rate="rate.pricetype_id">
                                                        <input type="number"
                                                               :value="getPriceValue(item.date, rate.pricetype_id, 'modified_price')"
                                                               readonly/>
                                                    </div>
                                                </template>
                                            </div>
                                            <div class="elm_cell">
                                                <div class="part_ui_input mod--active">
                                                    <input type="text"
                                                           :value="getPriceValue(item.date, rate.pricetype_id, 'modifier')"
                                                           v-on:change="changePrice($event.target.value, item.date, rate.pricetype_id, 'modifier', $event.target)"/>
                                                </div>
                                            </div>
                                        </template>
                                        <div class="elm_cell mod--low"></div>
                                        <div class="elm_cell" v-for="room in rooms">
                                            <div class="elm_cell"><span>{{
                                                    getSummaryValue(item.date, room)
                                                }}</span></div>
                                        </div>
                                        <div class="elm_cell mod--high mod--bottom" style="height: auto">
                                    <span class="elm_note">
                                        <div class="part_ui_input mod--active">
                                            <textarea :value="notes[item.date]"
                                                      v-on:change="changeNote($event.target.value, item.date)"
                                                      style="width: 100%;"></textarea>
                                        </div>
                                    </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </pull-to>
                <div class="elm_popper" v-show="popper.active">
                    <button @click="handlePopperDependency" v-show="popper.showDependency">{{
                            $t(popper.dependency)
                        }}
                    </button>
                    <button @click="handlePopperClosure">{{ $t(popper.closure) }}</button>
                    <div class="elm_popper_arrow"></div>
                </div>
                <div class="elm_popper" v-show="popperRoom.active">
                    <button @click="handlePopperClosureRoom">{{ $t(popperRoom.closure) }}</button>
                    <div class="elm_popper_arrow"></div>
                </div>
            </div>
            <div class="wrp_comp_button" style="border-bottom: 0">
                <button type="button" class="part_ui_btn part_ui_btn_primary" v-on:click="save"><span>{{
                        $t('save')
                    }}</span></button>
            </div>
        </div>
    </section>
</template>

<script>
import Popper from 'popper.js';
import axios from 'axios';
import moment from 'moment';
import PullTo from 'vue-pull-to';

const asyncForEach = async (array, callback) => {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
    }
};

export default {
    name: 'bookings-channel',
    components: {
        PullTo
    },
    data() {
        return {
            loading: false,
            top_options: {
                pullText: this.$i18n.t('pullText'), // The text is displayed when you pull down
                triggerText: this.$i18n.t('triggerText'), // The text that appears when the trigger distance is pulled down
                loadingText: this.$i18n.t('loadingText'), // The text in the load
                doneText: this.$i18n.t('doneText'), // Load the finished text
                failText: this.$i18n.t('failText'), // Load failed text
                loadedStayTime: 400, // Time to stay after loading ms
                stayDistance: 50, // Trigger the distance after the refresh
                triggerDistance: 70 // Pull down the trigger to trigger the distance
            },
            date_from: null,
            date_to: null,
            channel_id: null,
            channels: [],
            rooms: [],
            rates: [],
            prices: [],
            notes: {},
            availabilities: {},
            days: [],
            priceLists: [],
            priceListsAll: [],
            priceTypesAll: [],
            popper: {
                active: false,
                dependency: 'disable_dependency',
                closure: 'close'
            },
            popperRoom: {
                active: false,
                closure: 'close'
            },
            activeRate: null,
            activeRoom: null,
            activeDate: null,
            queue: [],
            date: null,
            selectDates: [],
            dates: {},
            tableHead: '',
            summary: {},
            preventClick: false,
            preventClickTimeout: null,
            show_decimals: true,
            show_tentative: false
        }
    },
    created() {
        this.date_from = new moment();
        this.date_to = new moment().add(7, 'd');
        this.date = this.date_from.format('YYYY-MM-DD');

        let selectDates = {};
        let fromDay = moment();
        let toDay = moment().add(1, 'years');
        let i = 0;

        while (fromDay <= toDay) {
            if (i === 0) {
                selectDates[fromDay.format('YYYY-MM-DD')] = this.$t('today');
            } else {
                selectDates[fromDay.format('YYYY-MM-DD')] = this.$t('week_from') + ' ' + fromDay.format('D. M.');
            }
            i++;
            fromDay = fromDay.clone().add(7, 'days');
        }

        this.selectDates = selectDates;

        this.getPriceTypes().then(() => {
            this.buildDates();
            this.getChannels();
        })

        this.channel_id = localStorage.getItem('default_channel_id');
        this.show_decimals = localStorage.getItem('show_decimals') === 'true';
        this.show_tentative = localStorage.getItem('show_tentative') === 'true';
    },
    mounted() {
        this.tableHead = this.$el.querySelectorAll('.elm_head_days');
    },
    methods: {
        buildDates: function () {
            let days = [];
            let fromDay = this.date_from.clone();
            let toDay = this.date_to.clone();

            while (fromDay <= toDay) {
                let d = {
                    day: fromDay.format('dd'),
                    date: fromDay.format('YYYY-MM-DD'),
                    dateFormatted: fromDay.format('D. M.'),
                };

                days.push(d);
                fromDay = fromDay.clone().add(1, 'd');
            }

            this.days = days;
        },
        changeChannel: function () {
            localStorage.setItem('channel_id', this.channel_id);
            this.reloadTable();
        },
        changeDate: function () {
            document.getElementById('maintable').scrollLeft = 0;

            this.date_from = new moment(this.date);
            this.date_to = new moment(this.date).add(7, 'd');
            this.buildDates();
            this.reloadTable();
        },
        // získá všechny dostupné kanály
        getChannels: function () {
            this.loading = true;

            let data = `{
                        id
                        channel_id
                        active
                        cm_room_types {
                          id
                          room_type_id
                          channel_room_type
                          online_sync
                          room_type {
                            technical
                            code
                          }
                        }
                        cm_room_rates {
                          id
                          channel_id
                          pricelist_id
                          pricetype_id
                          channel_rate_code
                          channel_room_type
                          online_sync
                          price_type {
                            code
                            parent_id
                          }
                          price_list {
                            code
                          }
                        }
                        cm_price_list_limits {
                          price_list_id
                          min_price
                        }
                    }`;

            let query = `{listCMChannels ${data}}`;

            axios({
                data: query
            }).then(response => {
                this.channels = response.data.data.listCMChannels;
                this.reloadTable();
            }).catch(error => {
                this.showError(error)
            });
        },
        // získá poznámky ke kalendáři
        getNotes: function () {
            let self = this;
            let data = `{
                        id
                        target_date
                        note
                    }`;

            let query = `{listCMDateInfo(date_from: "${this.date_from.format('YYYY-MM-DD')}", date_to: "${this.date_to.format('YYYY-MM-DD')}") ${data}}`;

            axios({
                data: query
            }).then(response => {
                let notes = {};
                response.data.data.listCMDateInfo.forEach(function (item) {
                    notes[item.target_date] = item.note;
                });
                self.notes = notes;
            }).catch(error => {
                this.showError(error)
            });
        },
        getCmData: function (loaded) {
            let data = `{
                        header_data {
                            date
                            free_rooms
                            confirmed_rooms
                            unconfirmed_rooms
                            tentative_rooms
                        }
                        cm_availability {
                            room_type_id
                            room_type {
                                id
                                code
                                description
                            }
                            availability {
                                id
                                room_type_id
                                channel_id
                                target_date
                                availability
                                closed
                            }
                        }
                        cm_prices {
                            price_type_id
                            price_type {
                                id
                                code
                                parent_id
                            }
                            price_list_id
                            price_list {
                                id
                                code
                                name
                            }
                            prices {
                                pl_price {
                                    id
                                    price_type_id
                                    price
                                    price_date
                                    closed
                                    closed_for_arrival
                                    updated_at
                                    modifier
                                    disable_parent
                                }
                                modified_price
                                closed_by_modifier
                            }
                        }
                    }`;

            let query = `{getCMCalendar(date_from: "${this.date_from.format('YYYY-MM-DD')}", date_to: "${this.date_to.add(1, 'd').format('YYYY-MM-DD')}", channel_id: "${this.channel_id}") ${data}}`;

            axios({
                data: query
            }).then(response => {
                let responseData = response.data.data.getCMCalendar;

                // header
                let dates = [];
                responseData.header_data.forEach(function (date) {
                    var d = date.date;

                    dates[d] = {};
                    dates[d].free_rooms = parseInt(date.free_rooms);
                    dates[d].confirmed_rooms = parseInt(date.confirmed_rooms);
                    dates[d].unconfirmed_rooms = parseInt(date.unconfirmed_rooms);
                    dates[d].tentative_rooms = parseInt(date.tentative_rooms);
                    dates[d].total_rooms = dates[d].free_rooms + dates[d].confirmed_rooms + dates[d].unconfirmed_rooms;
                });
                this.dates = dates;

                // availabilities
                let availabilities = {};
                responseData.cm_availability.forEach(function (room) {
                    room.availability.forEach(function (a) {
                        var d = a.target_date;

                        if (!availabilities[d]) {
                            availabilities[d] = {};
                        }

                        availabilities[d][room.room_type_id] = {
                            availability: a.availability,
                            closed: a.closed
                        };
                    });
                });
                this.availabilities = availabilities;

                // prices
                let prices = {};
                responseData.cm_prices.forEach(function (price) {
                    price.prices.forEach(function (p) {
                        var d = p.pl_price.price_date;
                        var pl_price = p.pl_price;

                        if (!prices[d]) {
                            prices[d] = {};
                        }

                        prices[d][price.price_type_id] = {
                            price: pl_price.price,
                            modified_price: p.modified_price,
                            closed: pl_price.closed,
                            modifier: pl_price.modifier,
                            disable_parent: pl_price.disable_parent,
                            closed_by_modifier: p.closed_by_modifier,
                        }
                    });
                });

                this.prices = prices;

                if (typeof loaded === 'function') {
                    loaded('done');
                }
            }).catch(error => {
                this.showError(error)
            });
        },
        // pošle změnu ceny do Horesu
        changePrice: function (value, date, priceTypeId, field, target) {
            let self = this;
            let minimum_price = 0;
            let modifierRe = /^(\d+\/(\d+|x);?)*$/;
            let priceListId;

            // get priceListId from priceTypeId because priceList is parent group
            this.priceListsAll.forEach(function (priceList) {
                if (priceList.price_types) {
                    priceList.price_types.forEach(function (priceType) {
                        if (priceType.id === priceTypeId) {
                            priceListId = priceList.id;
                        }
                    });
                }
            })

            // get active channel data
            let activeChannel = this.channels.find((obj) => obj.channel_id === self.channel_id);

            if (Array.isArray(activeChannel.cm_price_list_limits)) {
                activeChannel.cm_price_list_limits.forEach(function (priceLimit) {
                    if (priceLimit.price_list_id === priceListId) {
                        minimum_price = priceLimit.min_price;
                    }
                })
            }

            if (field === 'price' && parseFloat(value) < parseFloat(minimum_price)) {
                target.parentElement.classList.add('mod--invalid');
                self.$dialog.alert('Hodnota je menší než minimální cena, zadejte minimálně ' + minimum_price, {okText: 'Ok'});
            } else if (field === 'modifier' && value && !modifierRe.test(value)) {
                target.parentElement.classList.add('mod--invalid');
                self.$dialog.alert('Zadejte platnou hodnotu, lze pouze číslo/x nebo číslo/číslo', {okText: 'Ok'});
            } else {
                if (target) {
                    target.parentElement.classList.remove('mod--invalid');
                }
                let data = `
                    updateCMCalendar(
                        prices: {
                            price_type_id: ${priceTypeId}
                            price_date: "${date}"
                            ${field}: ${typeof value === 'boolean' ? '' : '"'}${value}${typeof value === 'boolean' ? '' : '"'}
                        },
                        channel_id: "${self.channel_id}"
                    )`;
                let return1 = `{
                        ok
                    }`;

                let query = `mutation updateCMCalendar {${data} ${return1}}`;

                if (field === 'disable_parent') {
                    axios({
                        data: query
                    }).then(response => {
                        let data = `{
                                cm_prices {
                                    prices {
                                        pl_price {
                                            price_type_id
                                            price
                                        }
                                        modified_price
                                    }
                                }
                            }`;

                        let query = `{getCMCalendar(date_from: "${date}", date_to: "${date}", channel_id: "${this.channel_id}") ${data}}`;

                        axios({
                            data: query
                        }).then(response => {
                            let responseData = response.data.data.getCMCalendar;
                            let currentPrices = self.prices;
                            responseData.cm_prices.forEach(function (price) {
                                price.prices.forEach(function (p) {
                                    if (priceTypeId === p.pl_price.price_type_id) {
                                        currentPrices[date][priceTypeId]['price'] = p.pl_price.price;
                                        currentPrices[date][priceTypeId]['modified_price'] = p.modified_price;
                                    }
                                });
                            });
                            self.prices = currentPrices;
                        }).catch(error => {
                            this.showError(error)
                        });
                    }).catch((error) => {
                        this.showError(error)
                    })
                } else {
                    this.queue.push(query);
                }
            }

            if (field === 'price') {
                self.prices[date][priceTypeId]['price'] = value;
                self.prices[date][priceTypeId]['modified_price'] = value;
            } else {
                self.prices[date][priceTypeId][field] = value;
            }
        },
        // pošle změnu dostupnosti do Horesu
        changeAvailability: function (value, date, roomTypeId, field) {
            let self = this;
            let data = `
                updateCMCalendar(
                    availability: {
                        room_type_id: ${roomTypeId}
                        target_date: "${date}"
                        ${field}: ${value}
                    },
                    channel_id: "${self.channel_id}"
                )`;
            let return1 = `{
                    ok
                }`;

            let query = `mutation updateCMCalendar {${data} ${return1}}`;

            this.queue.push(query);

            if (!self.availabilities[date]) {
                self.availabilities[date] = {};
            }

            if (!self.availabilities[date][roomTypeId]) {
                self.availabilities[date][roomTypeId] = {};
            }

            self.availabilities[date][roomTypeId][field] = value;
        },
        // pošle změnu poznámky do Horesu
        changeNote: function (value, date) {
            let self = this;
            let data = `
                updateCMCalendar(
                    date_info: {
                        target_date: "${date}"
                        note: "${value}"
                    },
                    channel_id: "${self.channel_id}"
                )`;
            let return1 = `{
                    ok
                }`;

            let query = `mutation updateCMCalendar {${data} ${return1}}`;

            this.queue.push(query);

            self.notes[date] = value;
        },
        handleInputClick: function (e, date, priceTypeId) {
            let el = e.target;

            if (el.classList.contains('part_ui_input')) {
                if (!el.classList.contains('mod--active') && !el.classList.contains('mod--popup')) {
                    el.classList.add('mod--active');
                    let input = el.childNodes[0];
                    input.focus();
                    input.addEventListener('blur', function () {
                        el.classList.remove('mod--active');
                    });

                    if (date && priceTypeId) {
                        this.prices[date][priceTypeId]['modified_price'] = this.prices[date][priceTypeId]['price'];
                        input.value = this.prices[date][priceTypeId]['price'];
                    }
                }
            }
        },
        handleInputDisabled: function () {
            if (!el.classList.contains('mod--popup')) {
                this.$dialog.alert('Cenu nelze změnit. Je nastavena závislost na jiné ceně', {okText: 'Ok'});
            }
        },
        handleInputFocus: function (e) {
            setTimeout(() => {
                e.target.closest('.scroll-container').scrollTop = e.target.closest('.elm_cell').offsetTop
            }, 100)
        },
        showPopup: function () {
            let self = this;

            return function (event) {
                event.target.classList.add('mod--popup');
                let date = event.target.getAttribute('data-date');
                self.activeDate = event.target.getAttribute('data-date');
                self.activeRate = event.target.getAttribute('data-rate');
                self.$data.popper = {
                    active: true,
                    dependency: self.getPriceValue(date, self.activeRate, 'disable_parent') ? 'enable_dependency' : 'disable_dependency',
                    showDependency: self.getPriceValue(date, self.activeRate, 'is_dependant'),
                    closure: self.getPriceValue(date, self.activeRate, 'closed') ? 'open' : 'close',
                };
                let el = document.querySelectorAll('.elm_popper')[0];
                new Popper(event.target, el, {
                    placement: 'top',
                });
                self.preventClick = true;
                clearTimeout(self.preventClickTimeout);
                self.preventClickTimeout = setTimeout(function () {
                    self.preventClick = false
                    event.target.classList.remove('mod--popup');
                }, 500)
            }
        },
        showPopupRoom: function () {
            let self = this;

            return function (event) {
                event.target.classList.add('mod--popup');
                let date = event.target.getAttribute('data-date');
                self.activeDate = event.target.getAttribute('data-date');
                self.activeRoom = event.target.getAttribute('data-room');
                self.$data.popperRoom = {
                    active: true,
                    closure: self.getAvailabilityValue(date, self.activeRoom, 'closed') ? 'open' : 'close',
                };
                let el = document.querySelectorAll('.elm_popper')[1];
                new Popper(event.target, el, {
                    placement: 'top',
                });
                self.preventClick = true;
                clearTimeout(self.preventClickTimeout);
                self.preventClickTimeout = setTimeout(function () {
                    self.preventClick = false
                    event.target.classList.remove('mod--popup');
                }, 500)
            }
        },
        hidePopup: function () {
            if (!this.preventClick) {
                this.popper.active = false;
                this.popperRoom.active = false;
            }
        },
        handlePopperDependency: function () {
            let val = this.getPriceValue(this.activeDate, this.activeRate, 'disable_parent');
            this.changePrice(!val, this.activeDate, this.activeRate, 'disable_parent');
        },
        handlePopperClosure: function () {
            let val = this.getPriceValue(this.activeDate, this.activeRate, 'closed');
            this.changePrice(!val, this.activeDate, this.activeRate, 'closed');
        },
        handlePopperClosureRoom: function () {
            let val = this.getAvailabilityValue(this.activeDate, this.activeRoom, 'closed');
            this.changeAvailability(!val, this.activeDate, this.activeRoom, 'closed');
        },
        handleScroll: function (event) {
            this.tableHead[0].style.left = event.target.scrollLeft * -1 + 'px';
        },
        getPriceValue: function (date, priceType, value) {
            if (value === 'is_dependant') {
                return !!this.priceTypesAll[priceType].parent_id;
            } else if (this.prices[date] && this.prices[date][priceType]) {
                if (value === 'is_modified_price') {
                    return this.prices[date][priceType]['price'] !== this.prices[date][priceType]['modified_price'];
                }

                if (value === 'is_editable') {
                    if (this.prices[date][priceType]['disable_parent']) {
                        return true;
                    }

                    return !this.priceTypesAll[priceType].parent_id;
                }

                if (!this.show_decimals && (value === 'price' || value === 'modified_price')) {
                    return Math.round(this.prices[date][priceType][value]);
                }

                return this.prices[date][priceType][value];
            } else if (value === 'is_editable') {
                return !this.priceTypesAll[priceType].parent_id;
            } else {
                return null;
            }
        },
        getAvailabilityValue: function (date, roomType, value) {
            if (this.availabilities[date] && this.availabilities[date][roomType]) {
                return this.availabilities[date][roomType][value];
            } else {
                return null;
            }
        },
        getCalendarValue: function (date, value) {
            if (this.dates[date]) {
                return this.dates[date][value];
            } else {
                return 0;
            }
        },
        reloadTable: function (loaded) {
            let self = this;
            this.loading = true;

            if (self.channel_id) {
                this.channels.forEach(function (item) {
                    if (item.channel_id === self.channel_id) {
                        let ratesUsed = [];
                        self.priceLists = [];
                        self.rooms = [];
                        self.rates = [];
                        // self.notes = [];

                        // for test hotel only, needs to be redone
                        let toSortArrayRooms = [
                            'DB',
                            'TW',
                            'SGL',
                            'TRP',
                            'DLX',
                            'DTR',
                            'JS',
                            'APT',
                            'FAM',
                        ];

                        let newArrRooms = item.cm_room_types.map(function (item) {
                            let idx = toSortArrayRooms.indexOf(item.room_type.code);

                            return {
                                val: item,
                                roleDefIndex: idx
                            };
                        });

                        item.cm_room_types = newArrRooms.sort(function (a, b) {
                            return a.roleDefIndex - b.roleDefIndex;
                        }).map(function (item) {
                            return item.val;
                        });

                        item.cm_room_types.forEach(function (itm) {
                            //if (itm.online_sync) {
                            self.rooms.push(itm);
                            //}
                        });

                        // for test hotel only, needs to be redone
                        let toSortArrayRates = [
                            '2BAR',
                            '2TOP',
                            '2B2B',
                        ];

                        let newArrRates = item.cm_room_rates.map(function (item) {
                            let idx = toSortArrayRates.indexOf(item.price_type.code);

                            return {
                                val: item,
                                roleDefIndex: idx
                            };
                        });

                        item.cm_room_rates = newArrRates.sort(function (a, b) {
                            return a.roleDefIndex - b.roleDefIndex;
                        }).map(function (item) {
                            return item.val;
                        });

                        item.cm_room_rates.forEach(function (itm) {
                            if (itm.online_sync && !ratesUsed.includes(itm.pricelist_id + '|' + itm.pricetype_id)) {
                                ratesUsed.push(itm.pricelist_id + '|' + itm.pricetype_id);
                                self.rates.push(itm);
                            }
                        });

                        item.cm_room_rates.forEach(function (itm) {
                            self.priceLists.push(itm.pricetype_id);
                        });

                        /*
                        item.cm_date_info.forEach(function (itm) {
                            self.notes[itm.target_date] = [itm.note];
                        });
                        */
                    }
                });

                this.getCmData(loaded);
                this.getNotes();
                this.occupancyChart();
            }
        },
        occupancyChart: function () {
            let self = this;

            axios({
                data: `{occupancyChart(date_from: "${this.date_from.format('YYYY-MM-DD')}", date_to: "${this.date_to.format('YYYY-MM-DD')}")}`
            }).then(response => {
                self.loading = false;
                let responseData = JSON.parse(response.data.data.occupancyChart);
                let dates = [];

                for (var d in responseData.dates) {
                    dates[d] = {};
                    for (const [key, value] of Object.entries(responseData.dates[d].used_rooms_by_type)) {
                        dates[d][key] = responseData.room_type_counts[key] - value;
                    }
                }

                this.summary = dates;
            }).catch(error => {
                this.showError(error)
            });
        },
        getPriceTypes: function () {
            this.loading = true;
            let self = this;

            return axios({
                data: `{
                        listPriceLists(deleted: false) {
                          id
                          code
                          name
                          price_types {
                            id
                            code
                            parent_id
                          }
                        }
                      }`
            }).then(response => {
                self.priceListsAll = response.data.data.listPriceLists;

                self.priceListsAll.forEach(function (priceList) {
                    if (Array.isArray(priceList.price_types)) {
                        priceList.price_types.forEach(function (priceType) {
                            self.priceTypesAll[priceType.id] = priceType;
                        })
                    }
                });
            }).catch(error => {
                this.showError(error)
            });
        },
        getSummaryValue: function (date, room) {
            if (typeof this.summary[date] !== 'undefined') {
                return this.summary[date][room.room_type_id];
            }
        },
        save: function () {
            let self = this;
            let errors = '';

            if (this.queue.length > 0) {
                (async function () {
                    await asyncForEach(self.queue, async (item) => {
                        await axios({
                            data: item
                        }).then(response => {
                            if (response.data.errors) {
                                errors += response.data.errors[0].message;
                            }
                        }).catch((error)=> {
                            this.showError(error)
                        });
                    });

                    if (errors) {
                        self.$dialog.alert(errors, {okText: 'Ok'});
                    } else {
                        self.$dialog.alert(self.$t('data_saved'), {okText: 'Ok'});
                        self.reloadTable();
                    }

                    self.queue = [];
                })();
            } else {
                self.$dialog.alert(self.$t('no_changes_to_save'), {okText: 'Ok'});
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/bookings-channel.vue